import { Box } from '@mui/material'
import { Suspense, useCallback, useRef, useState } from 'react'
import { Outlet } from 'react-router-dom'
import BaseFooter from '../footer/base-footer'
import BasicHeader from '../header/basic-header/basic-header'
import Spinner from '../spinner/spinner'

export type BasicPageLayoutOutletContext = {
  scrollRef: React.RefObject<HTMLDivElement | null>
}

type FooterVariant = 'full' | 'compact'

type BasicLayoutProps = {
  footerVariant?: FooterVariant
}

const LAYOUT_SX = {
  width: '100%',
  minHeight: '100vh',
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: 'white'
} as const

const MAIN_SX = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flexGrow: 1,
  bgcolor: 'white'
} as const

export default function BasicLayout({ footerVariant = 'compact' }: BasicLayoutProps) {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const [targetScroll, setTargetScroll] = useState<Node>()

  const setRefs = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      setTargetScroll(node)
      scrollRef.current = node
    }
  }, [])

  return (
    <Box id="basic-layout" ref={setRefs} sx={LAYOUT_SX}>
      <BasicHeader targetScroll={targetScroll} />

      <Suspense fallback={<Spinner fullScreen />}>
        <Box component="main" sx={MAIN_SX}>
          <Outlet context={{ scrollRef }} />
        </Box>
      </Suspense>

      <BaseFooter variant={footerVariant} />
    </Box>
  )
}
